import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { titleUpdated } from "../App/app";
import { AppDispatch } from "../store/store";

const useTitle = ( title: string ) => {

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch( titleUpdated( title ) );
  }, [ title ]);
}

export default useTitle;
